import $ from "jquery";
import { camelCase, startCase } from "lodash";
export const FG_AUDIT_A_CASE = "Audit a Case";
export const FG_AUDIT_VIEWER = "Audit Viewer";
export const FG_ALL_AUDIT_VIEWER = "All Audit Viewer";
export const FG_QA_REVIEW_OR_TASK_MANAGER = "QA Review/Task Manager";
export const FG_QA_REVIEWER = "QA Reviewer";
export const FG_AUDIT_MAINTENANCE = "Audit Maintenance";
export const FG_GLOBAL_AUDIT_MAINTENANCE = "Global Audit Maintenance";
export const FG_EXTERNAL_AUDIT_VIEWER = "External Audit Viewer";
export const FG_EXTERNAL_AUDIT_CREATION = "External Audit Creation";
export const FG_AUDIT_PROPERTY_EDITING = "Audit Property Editing";
export const FG_EXTERNAL_AUDIT_MAINTENANCE = "External Audit Maintenance";
export const FG_MANAGE_DELETED_AUDITS_CASES = "Manage Deleted Audits/Cases";
export const FG_MANUAL_AUDIT_CREATION = "Manual Audit Creation";
export const FG_EXTERNAL_USER_TASK_EDITING = "External User Task Editing";
export const FG_CASE_SEARCH_USER = "Case Search User";
export const HOSPITAL_WORKFLOW = "Hospital";
export const CODER_WORKFLOW = "Coder";
export const PROFESSIONAL_WORKFLOW = "Professional";
export const EXTERNAL_WORKFLOW = "External"
export const FG_UPDATE_COMPLETED_AUDITS_ENTITIES =
  "Update Completed Audits/Entities";
export const FG_AUDIT_REPORT = "Audit Reports";
export const FG_DOCUMENT_MANAGEMENT = "Document Management";
export const TASK_GROUPS ="Task Groups";
export const FG_DENIAL_PREDICTOR_MAINTENANCE = "Denials Predictor Maintenance";
export const hasAnyFeatureGroupAccess = (
  userFeatureKeys: string[],
  currentUser: any
): boolean => {
  if (
    currentUser &&
    currentUser.userPermissions &&
    currentUser.userPermissions.userFeatureKeys
  ) {
    const featureGroupKeys: string[] = currentUser.userPermissions.userFeatureKeys.map(
      (x) => x.featureGroupName
    );
    if (featureGroupKeys && featureGroupKeys.length) {
      for (var userFeatureKey of userFeatureKeys) {
        if (featureGroupKeys.includes(userFeatureKey)) {
          return true;
        }
      }
    }
  }
  return false;
};

export const hasWorkflowAccess=(
  workflow: string[],
  currentUser: any
): boolean=>{
  if (
    currentUser &&
    currentUser.userPermissions &&
    currentUser.userPermissions.userWorkFlow
  ) {
    const perm: string[] = currentUser.userPermissions.userWorkFlow.map(
        (x) => x.workFlowName
    );
    if(perm && perm.length){
      for(var wFlow of workflow){
        if(perm.includes(wFlow)){
          return true;
        }
      }
    }
  }
  return false;
};
export const hasAnyInternalAuditWorkFlowAccess = (
  currentUser: any): boolean => {
  if (
    currentUser &&
    currentUser.userPermissions &&
    currentUser.userPermissions.userWorkFlow
  ) {
    const perm: string[] = currentUser.userPermissions.userWorkFlow.map(
      (x) => x.workFlowName
    );
    if (perm && perm.length)
      // checking any Coder ,Hospital ,Professional is enabled as a workflow 
      if (perm.includes("Professional") || perm.includes("Hospital") || perm.includes("Coder")) {
        return true;
      }
      else {
        return false;
      }

  }
  return false;
}
export const getUserPermissionObject: any = (entities, currentUser) => {
  var entityList = entities.split("||");
  if (
    currentUser &&
    currentUser.userPermissions &&
    currentUser.userPermissions.userFeatureKeys
  ) {
    if (entityList.length > 1) {
      var param = {};
      var entityParam = {};
      for (var i = 0; i < entityList.length; i++) {
        var accessFeature = currentUser.userPermissions.userFeatureKeys;
        var areaRead = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_READ";
        });
        var areaCreate = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_CREATE";
        });
        var areaUpdate = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_UPDATE";
        });
        var areaDelete = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_DELETE";
        });
        var areaAdd = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_ADD";
        });
        var areaReac = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_REACCUMULATE";
        });
        var areaRef = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_REFRESH";
        });
        var areaMove = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_MOVE";
        });
        var areaUpload = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_UPLOAD";
        });
        var areaReplace = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_REPLACE";
        });
        var areaView = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_VIEW";
        });
        var areaRun = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_RUN";
        });
        var areaInfo = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_INFO";
        });
        var areaAlert = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_ALERT";
        });
        var areaHistory = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_HISTORY";
        });
        var areaPrint = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_PRINT";
        });
        var areaLink = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_LINK";
        });
        var areaWrite = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_WRITE";
        });
        var areaReportWrite = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_REPORT_WRITE";
        });
        var areaRestore = $.grep(accessFeature, (e: any) => {
          return e.featureKey == entityList[i] + "_RESTORE";
        });

        var entityName = startCase(camelCase(entityList[i])).replace(/ /g, "");
        entityParam[i] = {
          ["has" + entityName + "ReadAccess"]: areaRead.length > 0,
          ["has" + entityName + "CreateAccess"]: areaCreate.length > 0,
          ["has" + entityName + "UpdateAccess"]: areaUpdate.length > 0,
          ["has" + entityName + "DeleteAccess"]: areaDelete.length > 0,
          ["has" + entityName + "AddAccess"]: areaAdd.length > 0,
          ["has" + entityName + "ReacAccess"]: areaReac.length > 0,
          ["has" + entityName + "RefAccess"]: areaRef.length > 0,
          ["has" + entityName + "MoveAccess"]: areaMove.length > 0,
          ["has" + entityName + "UploadAccess"]: areaUpload.length > 0,
          ["has" + entityName + "ReplaceAccess"]: areaReplace.length > 0,
          ["has" + entityName + "ViewAccess"]: areaView.length > 0,
          ["has" + entityName + "CancelAccess"]:
            areaRead.length > 0 ||
            areaCreate.length > 0 ||
            areaUpdate.length > 0,
          ["has" + entityName + "RunAccess"]: areaRun.length > 0,
          ["has" + entityName + "InfoAccess"]: areaInfo.length > 0,
          ["has" + entityName + "AlertAccess"]: areaAlert.length > 0,
          ["has" + entityName + "HistoryAccess"]: areaHistory.length > 0,
          ["has" + entityName + "PrintAccess"]: areaPrint.length > 0,
          ["has" + entityName + "LinkAccess"]: areaLink.length > 0,
          ["has" + entityName + "WriteAccess"]: areaWrite.length > 0,
          ["has" + entityName + "RestoreAccess"]: areaRestore.length > 0,
        };
      }
      for (var item in entityParam) {
        for (var prop in entityParam[item]) {
          if (
            entityParam[item].hasOwnProperty(prop) &&
            !param.hasOwnProperty(prop)
          ) {
            param[prop] = entityParam[item][prop];
          }
        }
      }
      return param;
    } else {
      const accessFeature = currentUser.userPermissions.userFeatureKeys;
      const areaRead = $.grep(accessFeature, (e: any) => {
        return e.featureKey == entityList + "_READ";
      });
      const areaCreate = $.grep(accessFeature, (e: any) => {
        return e.featureKey == entityList + "_CREATE";
      });
      const areaUpdate = $.grep(accessFeature, (e: any) => {
        return e.featureKey == entityList + "_UPDATE";
      });
      const areaDelete = $.grep(accessFeature, (e: any) => {
        return e.featureKey == entityList + "_DELETE";
      });
      const areaUpload = $.grep(accessFeature, (e: any) => {
        return e.featureKey == entityList + "_UPLOAD";
      });
      const areaRun = $.grep(accessFeature, (e: any) => {
        return e.featureKey == entityList + "_RUN";
      });
      const areaCopy = $.grep(accessFeature, (e: any) => {
        return e.featureKey == entityList + "_COPY";
      });
      const areaAdd = $.grep(accessFeature, (e: any) => {
        return e.featureKey == entityList + "_ADD";
      });
      var areaRestore = $.grep(accessFeature, (e: any) => {
        return e.featureKey == entityList[i] + "_RESTORE";
      });

      const param = {
        hasReadAccess: areaRead.length > 0,
        hasCreateAccess: areaCreate.length > 0,
        hasUpdateAccess: areaUpdate.length > 0,
        hasDeleteAccess: areaDelete.length > 0,
        hasCancelAccess:
          areaRead.length > 0 || areaCreate.length > 0 || areaUpdate.length > 0,
        hasUploadAccess: areaUpload.length > 0,
        hasRunAccess: areaRun.length > 0,
        hasCopyAccess: areaCopy.length > 0,
        hasAddAccess: areaAdd.length > 0,
        hasRestoreAccess:areaRestore.length>0,
      };
      return param;
    }
  }
  return {};
};

export interface IPermissionsObject {
  hasReadAccess: boolean;
  hasCreateAccess: boolean;
  hasUpdateAccess: boolean;
  hasDeleteAccess: boolean;
  hasCancelAccess: boolean;
  hasUploadAccess: boolean;
  hasRunAccess: boolean;
  hasCopyAccess: boolean;
  hasAddAccess: boolean;
  hasRestoreAccess: boolean;
}
